import { Typography } from '@spotnana/blocks/src/Typography';
import { Row, SubTextContainer } from './styles';

interface IProps {
  label: string;
  value: string;
  subTextLeft?: string;
  subTextRight?: string;
}

const SubHeading = ({ label, value, subTextLeft, subTextRight }: IProps) => {
  return (
    <>
      <Row data-testid="fare-breakup-row">
        <Typography variant="body1" kind="semibold" as="dt">
          {label}
        </Typography>
        <Typography variant="body1" kind="semibold" as="dd">
          {value}
        </Typography>
      </Row>
      {Boolean(subTextLeft || subTextRight) && (
        <SubTextContainer subTextLeft={subTextLeft} subTextRight={subTextRight}>
          <>
            {subTextLeft && (
              <Typography variant="body2" color="secondary" as="span">
                {subTextLeft}
              </Typography>
            )}
            {subTextRight && (
              <Typography variant="body2" color="secondary" as="span">
                {subTextRight}
              </Typography>
            )}
          </>
        </SubTextContainer>
      )}
    </>
  );
};

export default SubHeading;
